import { z } from 'zod';

import { hasAtMostFourDecimals } from '#/modules/crmMgmt/costEstimate/helper/costEstimateLines';

export const COST_ESTIMATE_FIELD_LABELS = {
  name: '試算名稱',
  roundingMode: '總額取整',
  remark: '備註',
  lines: '試算明細',
};

const LINE_FIELD_LABELS = {
  qty: '數量',
  unitPrice: '單價',
  remark: '明細備註',
};

export function resolveCostEstimateFieldLabel(path) {
  const parts = String(path).split('.');
  if (parts[0] === 'lines' && parts.length >= 3) {
    return `明細第 ${Number(parts[1]) + 1} 列 ${LINE_FIELD_LABELS[parts[2]] ?? parts[2]}`;
  }
  return COST_ESTIMATE_FIELD_LABELS[parts[0]] ?? path;
}

/** numeric(20,4)：整數部分最多 16 位（be doc f77b08e9 COST_ESTIMATE_QTY_INVALID）。 */
function hasAtMostSixteenIntegerDigits(value) {
  const integerPart = String(value).trim().replace(/^[+-]/, '').split('.')[0].replace(/^0+(?=\d)/, '');
  return integerPart.length <= 16;
}

const lineSchema = z.object({
  key: z.string(),
  lineId: z.string().nullable().optional(),
  mtrId: z.string().min(1, '請選擇物料'),
  mtrNo: z.string().optional().nullable(),
  name: z.string().optional().nullable(),
  baseUnitName: z.string().optional().nullable(),
  qty: z.union([z.string(), z.number()]),
  unitPrice: z.union([z.string(), z.number(), z.null()]).optional(),
  remark: z.string().optional().nullable(),
}).superRefine((line, ctx) => {
  const qty = Number(line.qty);
  if (line.qty === '' || Number.isNaN(qty) || qty <= 0) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: '數量須大於 0', path: ['qty'] });
  } else if (!hasAtMostFourDecimals(line.qty)) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: '數量最多四位小數', path: ['qty'] });
  } else if (!hasAtMostSixteenIntegerDigits(line.qty)) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: '數量最多 16 位整數', path: ['qty'] });
  }

  if (line.unitPrice !== '' && line.unitPrice != null) {
    const price = Number(line.unitPrice);
    if (Number.isNaN(price) || price < 0) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: '單價不可為負', path: ['unitPrice'] });
    } else if (!hasAtMostFourDecimals(line.unitPrice)) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: '單價最多四位小數', path: ['unitPrice'] });
    }
  }
});

export const costEstimateFormSchema = z.object({
  name: z.string().trim().min(1, '請輸入試算名稱'),
  roundingMode: z.string().min(1, '請選擇總額取整方式'),
  remark: z.string().optional().nullable(),
  lines: z.array(lineSchema),
});
